import React from 'react'

export default (props) => {
  const {
    text
  } = props

  if (!text) {
    return null
  }

  return (
    <h2 className="genre-header">
      <span className="genre-header__text">{text}</span>
    </h2>
  )
}



// WEBPACK FOOTER //
// ./src/desktop/components/genre-header/index.js